'use client'

import Script from 'next/script'
import { sleep } from '@segway/core'

/**
 * Accessibe 插件
 */
const Accessibe = () => {
  return (
    <Script
      strategy="lazyOnload"
      src="https://acsbapp.com/apps/app/dist/js/app.js"
      onLoad={async () => {
        await sleep(500)
        window?.acsbJS?.init({
          statementLink: '',
          footerHtml: '',
          hideMobile: false,
          hideTrigger: false,
          disableBgProcess: false,
          language: 'en',
          position: 'right',
          leadColor: '#146FF8',
          triggerColor: '#146FF8',
          triggerRadius: '50%',
          triggerPositionX: 'right',
          triggerPositionY: 'bottom',
          triggerIcon: 'people',
          triggerSize: 'bottom',
          triggerOffsetX: 20,
          triggerOffsetY: 20,
          mobile: {
            triggerSize: 'small',
            triggerPositionX: 'right',
            triggerPositionY: 'bottom',
            triggerOffsetX: 10,
            triggerOffsetY: 10,
            triggerRadius: '20',
          },
        })
      }}
    />
  )
}

export default Accessibe
